import { render } from "./Order_ticket.vue?vue&type=template&id=28fe0fe4&scoped=true"
import script from "./Order_ticket.vue?vue&type=script&lang=js"
export * from "./Order_ticket.vue?vue&type=script&lang=js"

import "./Order_ticket.vue?vue&type=style&index=0&id=28fe0fe4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fe0fe4"]])

export default __exports__